import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MessagesContext from '../../../contexts/messagesContext';
import { getGenericList } from '../../../redux/General/GeneralAction';

const usePatientFields = () => {
    const cities = useSelector((state) => state.general?.generics?.cities);
    const nationalityOptions = useSelector((state) => state.general?.generics?.nationalities);
    const dispatch = useDispatch();
    const { messages } = useContext(MessagesContext);

    useEffect(() => {
        if (!cities?.length) {
            dispatch(getGenericList('city'));
        }
        if (!nationalityOptions?.length) {
            dispatch(getGenericList('nationality'));
        }
    }, []);

    const patientFields = {
        name: 'patient',
        fields: [
            {
                id: 'first_name',
                name: messages.firstName,
                data_type: 'char'
            },
            {
                id: 'last_name',
                name: messages.lastName,
                data_type: 'char'
            },
            {
                id: 'dob',
                name: messages.birthDate,
                data_type: 'date'
            },
            {
                id: 'gender',
                name: messages.gender,
                data_type: 'select',
                presentation: {
                    required: false,
                    selectType: 0,
                    displayType: 1
                },
                metadata: {
                    min: 0,
                    max: 1,
                    items: [
                        ['M', messages.male],
                        ['F', messages.female],
                        ['O', messages.nonBinary]
                    ],
                    restricted: false
                }
            },
            {
                id: 'birth_location',
                name: messages.birthplace,
                data_type: 'select',
                presentation: {
                    required: false,
                    selectType: 0,
                    displayType: 1
                },
                metadata: {
                    min: 0,
                    max: 1,
                    items: cities?.map((item) => [item.id.toString(), item.title]),
                    restricted: false
                }
            },
            {
                id: 'city',
                name: messages.city,
                data_type: 'select',
                presentation: {
                    required: false,
                    selectType: 0,
                    displayType: 1
                },
                metadata: {
                    min: 0,
                    max: 1,
                    items: cities?.map((item) => [item.id.toString(), item.title]),
                    restricted: false
                }
            },
            {
                id: 'marital_status',
                name: messages.maritalStatus,
                data_type: 'select',
                presentation: {
                    required: false,
                    selectType: 0,
                    displayType: 1
                },
                metadata: {
                    min: 0,
                    max: 1,
                    items: [
                        ['S', messages.single],
                        ['M', messages.married],
                        ['D', messages.divorced],
                        ['W', messages.widowed]
                    ],
                    restricted: false
                }
            },
            {
                id: 'nationality',
                name: messages.nationality,
                data_type: 'select',
                presentation: {
                    required: false,
                    selectType: 0,
                    displayType: 1
                },
                metadata: {
                    min: 0,
                    max: 1,
                    items: nationalityOptions?.map((item) => [item.id.toString(), item.title]),
                    restricted: false
                }
            }
        ]
    };
    return patientFields;
};

export default usePatientFields;
